import { createContext, useContext, useRef, useCallback } from 'react';

const PageShortcutContext = createContext({});

export const PageShortcutProvider = ({ children }) => {
  const callbacksRef = useRef({});

  const registerCallbacks = useCallback((cbs) => {
    callbacksRef.current = { ...callbacksRef.current, ...cbs };
  }, []);

  const clearCallbacks = useCallback(() => {
    callbacksRef.current = {};
  }, []);

  const getCallbacks = useCallback(() => callbacksRef.current, []);

  return (
    <PageShortcutContext.Provider value={{ registerCallbacks, clearCallbacks, getCallbacks }}>
      {children}
    </PageShortcutContext.Provider>
  );
};

export const usePageShortcuts = () => useContext(PageShortcutContext);
